// Persian date utility functions

/**
 * Convert Gregorian date to Persian/Shamsi date string
 */
export const toPersianDate = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  try {
    return dateObj.toLocaleDateString('fa-IR-u-nu-latn', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  } catch (error) {
    // Fallback to basic format if toLocaleDateString fails
    return dateObj.toLocaleDateString('fa-IR');
  }
};

/**
 * Convert Gregorian date to Persian/Shamsi date and time string
 */
export const toPersianDateTime = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  try {
    const dateStr = dateObj.toLocaleDateString('fa-IR-u-nu-latn', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    
    const timeStr = dateObj.toLocaleTimeString('fa-IR-u-nu-latn', {
      hour: '2-digit',
      minute: '2-digit'
    });
    
    return `${dateStr} ${timeStr}`;
  } catch (error) {
    // Fallback to basic format if toLocaleDateString fails
    const dateStr = dateObj.toLocaleDateString('fa-IR');
    const timeStr = dateObj.toLocaleTimeString('fa-IR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    return `${dateStr} ${timeStr}`;
  }
};

/**
 * Format Persian date with time
 */
export const formatPersianDateTime = (dateString: string): string => {
  if (!dateString) return '---';
  return toPersianDateTime(dateString);
};

/**
 * Format Persian date only
 */
export const formatPersianDate = (dateString: string): string => {
  if (!dateString) return '---';
  return toPersianDate(dateString);
};